import { render, staticRenderFns } from "./AllProjectsLoaderState.vue?vue&type=template&id=48f48a4b&"
import script from "./AllProjectsLoaderState.vue?vue&type=script&lang=js&"
export * from "./AllProjectsLoaderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports